// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab5aa8f3","455":"eabedaf3","977":"f8867ade"}[chunkId] + ".chunk.js";
};